import { ApiResource } from 'app/services/api/enums';

export const buildApiPath = (base: ApiResource, prefix = ''): string =>
  `/${base}${prefix ? '/' + prefix : ''}`;
